import React, { useState } from 'react'
import { Card, Col, Flex, Form, Row, Typography } from 'antd'
import {AddPaymentMethod, Appointmenttable, ModuleTopHeading, Paymenttable, SearchInput } from '../../components';

const { Text } = Typography
const Payment = () => {
   
    return (
        <>
            <Card className='shadow-d radius-12'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Flex vertical gap={20}>
                            <ModuleTopHeading level={4} name='Payment'/>
                        </Flex>
                    </Col>
                    <Col span={24}>
                       <Paymenttable />
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export { Payment }
